import { Container } from '@/components/ui/Container'
import { Section } from '@/components/ui/Section'
import { siteConfig } from '@/config/site'

export function AboutHeroSection() {
  return (
    <Section surface="0" className="pt-10 pb-10 sm:pt-16 sm:pb-14 md:pt-24 md:pb-20">
      <Container className="max-w-4xl">
        <span className="font-mono text-xs uppercase tracking-widest text-fg-muted mb-3 sm:mb-4 block">
          Corporate Background
        </span>
        <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-fg text-balance leading-tight">
          Engineering Software to Set the Regional Standard.
        </h1>
        <p className="mt-4 sm:mt-6 text-sm sm:text-lg md:text-xl text-fg-subtle leading-relaxed">
          {siteConfig.name} is an Ethiopian technology enterprise dedicated to building resilient digital infrastructure, custom software, and specialized SaaS platforms.
        </p>
      </Container>
    </Section>
  )
}
